__turbopack_context__.v({
  "fullBodySection": "ProfilePhotos-module-scss-module__Fap1zq__fullBodySection",
  "headshotSection": "ProfilePhotos-module-scss-module__Fap1zq__headshotSection",
  "profilePhotosContainer": "ProfilePhotos-module-scss-module__Fap1zq__profilePhotosContainer",
});
